export default __webpack_public_path__ + "static/media/01.a7686d49.png";